import {createGlobalStyle} from 'styled-components';

import {compositionEditorLimits} from '../constants/compositionEditorLimits';
import {getBuiltInFontFaceRules} from '../utils/getBuiltInFontFaceRules';

/**
 * Inter Regular/Bold are the server's built-in composition font. They are registered only while
 * the editor is mounted so the rest of the app keeps its own typeface untouched. The files are
 * copied to `/assets/fonts` by the DMS app build (see apps/dms/rspack.config.ts).
 */
export const BuiltInFontStyles = createGlobalStyle`
  ${getBuiltInFontFaceRules(compositionEditorLimits.builtInFontFamily)}
`;
